var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1004,
    height: 116,
    viewBox: "0 0 1004 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M965.944 103.919H965.943L912.278 44.1254V44.1242L965.944 103.919ZM971.936 103.919V104.055H971.937V103.919H971.936ZM1003.81 104.055H1003.81V103.919V8.57422H1003.81V104.055ZM971.937 8.57422H971.936V68.3678L918.271 8.57422H918.27L971.936 68.369V68.3678L971.937 68.369V8.57422ZM880.27 8.57422H880.268V104.055H880.27V103.919V8.57422ZM912.277 104.055H912.278V44.1254L912.277 44.1242V104.055ZM909.669 37.313V101.447H882.877V11.1825H917.106L974.544 75.1802V11.1825H1001.2V101.447H974.544V101.311H967.106L909.669 37.313ZM878.394 103.919H877.66V102.691L878.394 103.919Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M880.268 104.055V101.971L881.512 104.055H880.268ZM841.208 103.919L832.491 89.481H832.489L841.206 103.919H841.208ZM878.391 103.919H878.393L821.458 8.57422H821.456L878.391 103.919ZM776.237 8.57422H776.235L719.301 103.919H719.303L776.237 8.57422ZM756.485 103.919H756.487L765.068 89.481H765.066L756.485 103.919ZM716.229 104.055H716.184L716.229 103.98V104.055ZM763.584 86.8728L755.003 101.311H723.898L777.718 11.1825H819.978L873.797 101.311H842.68L833.963 86.8728H763.584ZM798.856 27.861L775.588 66.7549H821.954L798.856 27.861ZM798.848 32.9552L817.372 64.1466H817.37L798.847 32.957L798.848 32.9552ZM780.187 64.1466L798.847 32.957L798.846 32.9552L780.185 64.1466H780.187Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M686.824 101.449V11.1846H713.616V101.449H686.824Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.96 80.65H672.103V101.449H572.168V11.1846H598.96V80.65Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.613 82.5569H556.706V101.585H452.957V11.1846H556.706V29.9404H479.613V47.007H551.394V65.7628H479.613V82.5569Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M422.445 51.3961L417.275 54.3507L422.952 56.1475C432.734 59.2429 439.655 67.981 439.655 78.0417C439.655 90.386 429.345 100.662 416.185 101.313H324.465V11.1846H410.465C423.756 11.8393 433.798 21.5505 433.798 32.9573C433.798 40.6105 429.378 47.4347 422.445 51.3961ZM397.179 29.9404H351.257V46.8707H397.179C399.57 46.8707 401.93 46.2562 403.762 44.8882C405.663 43.4688 406.87 41.3147 406.87 38.678C406.87 33.4944 402.207 29.9404 397.179 29.9404ZM402.9 65.6266H351.257V82.5569H402.9C407.927 82.5569 412.591 79.0029 412.591 73.8193C412.591 71.2283 411.366 69.0911 409.501 67.6735C407.685 66.2935 405.328 65.6266 402.9 65.6266Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.864 103.921V103.862L321.899 103.921H321.864ZM204.053 86.8748L195.472 101.313H164.367L218.187 11.1846H260.447L314.266 101.313H283.149L274.432 86.8748H204.053ZM239.325 27.8631L216.056 66.7569H262.423L239.325 27.8631Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6158 0L112.189 116H156.338L86.9536 0H43.6158ZM21.6898 109.453L21.6848 109.445L21.6785 109.445L21.6817 109.439L-0.0078125 72.6263L21.6453 36.3882L43.5794 72.9449L43.6176 72.8811H84.2176L62.3317 109.643L21.6949 109.445L21.6898 109.453Z",
    fill: "#3638FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6158 0L112.189 116H156.338L86.9536 0H43.6158ZM21.6898 109.453L21.6848 109.445L21.6785 109.445L21.6817 109.439L-0.0078125 72.6263L21.6453 36.3882L43.5794 72.9449L43.6176 72.8811H84.2176L62.3317 109.643L21.6949 109.445L21.6898 109.453Z",
    fill: "url(#paint0_linear_1055_3169)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1055_3169",
    x1: 7.56447,
    y1: 116.967,
    x2: 148.818,
    y2: 110.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.743b7aa4fd033579889fdb3059d601b4.svg";
export { ForwardRef as ReactComponent };